import { frontendURL } from 'dashboard/helper/URLHelper';
import InboxListView from './InboxList.vue';
import InboxDetailView from './InboxView.vue';
import InboxEmptyStateView from './InboxEmptyState.vue';
import {
  INBOX_VIEW_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const inboxRoutePermissions = {
  anyOf: [
    'administrator',
    LEGACY_AGENT_ONLY_PERMISSIONS,
    INBOX_VIEW_PERMISSIONS,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    component: InboxListView,
    children: [
      {
        path: '',
        name: 'inbox_view',
        component: InboxEmptyStateView,
        meta: {
          permissions: inboxRoutePermissions,
        },
      },
      {
        path: ':type/:id',
        name: 'inbox_view_conversation',
        component: InboxDetailView,
        meta: {
          permissions: inboxRoutePermissions,
        },
      },
    ],
  },
];
